/**
 * Empty Data Manager extension manifest.
 *
 * The Data Manager imports `@afriannotate/dm-extensions` where it lets an
 * extension change how a project's work is listed and done. The build
 * resolves that name to the file `dm.ts` beside the package named by
 * AFRI_EXTENSIONS_DIR when one is installed, and to this stub otherwise.
 *
 * Shape (everything optional):
 *   modes:      [(project) => mode | null]; the first mode returned applies
 *               to the project. A mode may have:
 *     listsAnnotations  the table lists annotations, one row each, not tasks
 *     repeat            a task takes many annotations from one person: Submit
 *                       saves one and opens a fresh form on the same task
 *     words             { labelButton, saved(n), notSaved, updated, notUpdated,
 *                         deleted, notDeleted, deleteTitle, deleteBody }
 *     footer(counts)    [{ label, title?, value }] for the table's footer;
 *                       counts = { rows, tasks, annotations, predictions }
 *     toolbar           [{ id, label, event }] buttons that emit `event`
 *     Grid              component for the grid view ({ view, data, loadMore })
 *     LabelPanel        component shown above the editor ({ SDK })
 *   cells:      { [ColumnAlias]: CellComponent } extra table cells
 *   endpoints:  { name: "/path/:param" } added to the Data Manager's API
 */
export const modes: Array<(project: unknown) => Record<string, unknown> | null> = [];
export const cells: Record<string, unknown> = {};
export const endpoints: Record<string, string> = {};
